var $main_step = '';
 $(document).on('click', '[data-select]', function(e){
  var $this = $(this);
  var $step = $(this).closest('[data-step]');
  var $next = $step.nextAll('[data-step]').first();
  $this.addClass('selected');
  $step.find('[data-select]').not($this).removeClass('selected');
  $step.addClass('selected').removeClass('active');
  
  if(!$next.hasClass('selected')) {
  	$next.addClass('active');
  }
  
  if($step.hasClass('step1')) {
    $('[data-summary="location"] span').text($this.attr('data-variant'));
    $('[data-shipping-label]').text($this.attr('data-shipping'));
  }
  if($step.hasClass('step2')) {
    $('[data-summary="use"] span').text($this.attr('data-variant'));
  }
  if($step.hasClass('step3')) {
    $('[data-summary="'+$this.attr('data-val')+'"] span').text($this.attr('data-variant'));
  }
 
  if($step.hasClass('step2') || $step.hasClass('step3')) {
    var $step2_value = $('#step2').find('.selected[data-select]').attr('data-val');
    var $step3_value = $('#step3').find('.selected[data-select]').attr('data-val');
    $main_step = $('[data-main-step][data-type="'+$step2_value+'_'+$step3_value+'"]');
    $main_step.removeClass('hide');
    $main_step.siblings('[data-main-step]').addClass('hide');
   
  }
 
   if($main_step.length) {
      if($main_step.find('.active[data-step-inner]').length) {
        $next = $main_step.find('.active[data-step-inner]');
      }
      else {
     	$next = $main_step.find('[data-step-inner]').first().addClass('active');
      }
   }
 
  if($next.length) {
    $('html, body').animate({
         scrollTop: $next.offset().top - 200
    }, 800);
  }
});

// function updatePrice($type, $price_path){
//   var $price = $('[data-product-'+$type+']').attr('data-price-'+$value1+'-'+$value2);
//   $main.find('[data-price]').text($price);
// }
 var $flag_coffee = false;
 var $flag_pods = false;
$(document).on('click', '[data-select-inner]', function(e){
  var $this = $(this);
  var $step = $(this).closest('[data-step-inner]');
  var $main = $step.closest('[data-main-step]');
  if($main.find('.active[data-step-inner]').not($step).length) {
   	var $next = $main.find('.active[data-step-inner]');
  }
  else {
   	var $next = $step.nextAll('[data-step-inner]').first();
    $next.addClass('active');
  }
  $this.addClass('selected');
  $step.find('[data-select-inner]').not($this).removeClass('selected');
  $step.addClass('selected').removeClass('active');
 
  var $index = $step.attr('data-index');
  $main.find('[data-summary="'+$index+'"] span').text($this.attr('data-variant'));
  var $type = $main.attr('data-type');
  
  console.log('$type', $type);
 
  
  if($type == 'home_coffee') {
     if($flag_coffee) {
      var $value1 = $main.find('[data-step-inner][data-index="3"]').find('.selected[data-select-inner]').attr('data-val');
      var $value2 = $main.find('[data-step-inner][data-index="1"]').find('.selected[data-select-inner]').attr('data-val');
      var $value3 = $main.find('[data-step-inner][data-index="2"]').find('.selected[data-select-inner]').attr('data-val');
      var $price = $('[data-product-'+$type+']').attr('data-price-'+$value1+'-'+$value2+'-'+$value3);
      $main.find('[data-price]').text($price);
    }
    if($index == 2) {
      $flag_coffee = true;
      var $value1 = $main.find('[data-step-inner][data-index="3"]').find('.selected[data-select-inner]').attr('data-val');
      var $value2 = $main.find('[data-step-inner][data-index="1"]').find('.selected[data-select-inner]').attr('data-val');
      var $value3 = $main.find('[data-step-inner][data-index="4"]').find('.selected[data-select-inner]').attr('data-val');
      var $price = $('[data-product-'+$type+']').attr('data-price-'+$value1+'-'+$value2+'-'+$value3);
      $main.find('[data-price]').text($price);
    }
  }
  
  
  if($next.length) { 
    $('html, body').animate({
         scrollTop: $next.offset().top - 200
    }, 800);
  }
});

$(document).on('click', '[data-add]', function(e){
  $(this).attr('disabled', 'disabled');
  var $type = $(this).attr('data-add');
  var $main = $('[data-main-step][data-type="'+$type+'"]');
 if($type == 'home_coffee') {
    var $value1 = $main.find('[data-step-inner][data-index="3"]').find('.selected[data-select-inner]').attr('data-val');
  	var $value2 = $main.find('[data-step-inner][data-index="1"]').find('.selected[data-select-inner]').attr('data-val');
    var $value3 = $main.find('[data-step-inner][data-index="2"]').find('.selected[data-select-inner]').attr('data-val');
  	var $variant_id = $('[data-product-'+$type+']').attr('data-'+$value1+'-'+$value2+'-'+$value3);
  }
  
  //console.log("val="+$value1);
  //console.log("val2="+$value2);
  //console.log("val3="+$value3);
  //console.log("$variant_id="+$variant_id);
  //console.log('data-'+$value1+'-'+$value2+'-'+$value3);
  
 // var $method = $main.find('[data-step-inner][data-index="4"]').find('.selected[data-select-inner]').attr('data-variant');
  var $selling_plan_id = $main.find('[data-step-inner][data-index="4"]').find('.selected[data-select-inner]').attr('data-val');
  console.log($variant_id, $selling_plan_id);
  var data = {
    id: $variant_id,
    selling_plan: $selling_plan_id
//     properties: {
//       "Method": $method
//     }
  };
  console.log(data);
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(data) { 
     window.location.href="/cart";
    },
    error: function(error){
      console.log('error', error);
    }
  });
  
  
});
